export enum PropertyStatusType {
    Pending = 0,
    Appraise = 1,
    AppraisalOrdered = 2,
    AppraisalReceived = 3,
    AppraisalReviewed = 4,
    Approved = 5,
    Deleted = 6,
}
